jQuery(document).ready(function($) {
  const client = ShopifyBuy.buildClient({
      domain: 'fullfactory-b2c.myshopify.com',
      storefrontAccessToken: '19750c8b13b88c94b3a54674c5c17a4c'
    });
  
  // Load Product by Handle
  product_load = function(product_handle,active_item=null) {
    const product_query = client.graphQLClient.query((root) => {
      root.add(
        "productByHandle",
        { args: { handle: product_handle } },
        (Product) => {
          Product.add("title");
          Product.add("handle");
          Product.add("productType");
          Product.addConnection(
            "images",
            { args: { first: 1 } },
            (Image) => {
              Image.add("src");
            }
          );
        }
      );
    });
    client.graphQLClient.send(product_query).then(({ model }) => {
      const product = model.productByHandle;
      if (product) {
        active_item.append(product_load_link('https://shop.'+brand_url+'.com/products/'+product.handle,product.title,product.images));
      } else {
        console.log("Product not found.");
      }
    }).catch((error) => {
      console.error("Error:", error);
    });
  };

  // Load Product for Collection
  product_load_link = function(link_url,link_title,product_images=null) {
    var product_images_html = '';
      link_title = link_title.split('(');
      link_title = link_title[0];
    if(link_title.includes(' x ') || link_title.includes(' & ') || link_title.includes(' &amp; ')) {
    } else {
      link_title = link_title.replace(brand+' ','');
    };
    if(product_images) {
      if(product_images.length>1) {
        for (image in product_images) {
          product_images_html += '<span class="img" style="background-image:url(\''+image.src.replace('.jpg','_large.jpg')+'\')"></span>';
        }
      } else {
        product_images_html = '<span class="img" style="background-image:url(\''+product_images[0].src.replace('.jpg','_large.jpg')+'\')"></span>';
      };
    } else {
      product_images_html = '<span class="img">&nbsp;</span>';
    };
    return '<a href="'+link_url+'">'+product_images_html+'<span class="title">'+link_title+'</span></a>';
  };
  
  // Load Collection and its Products
  collection_load = function(collection_handle,collection_dom,product_count=30,linkto='product') {
    var container_counter = 0,
        col_size = 'col20 col-maxwidth33';
    const collection_container = $(collection_dom).find('.row');
    const collection_title_a = $(collection_dom).find('h3.shopify-collection-title a');
    
    if(collection_dom=='#signature') {
      col_size = 'col25 col-maxwidth50';
    };
    const collection_query = client.graphQLClient.query((root) => {
      root.add(
        "collectionByHandle",
        { args: { handle: collection_handle }, alias: "collection" },
        (Collection) => {
          Collection.add("id");
          Collection.add("title");
          Collection.add("handle");
          Collection.addConnection(
            "products",
            { args: { first: product_count } },
            (Product) => {
              Product.add("title");
              Product.add("handle");
              Product.add("productType");
              Product.addConnection(
                "images",
                { args: { first: 1 } },
                (Image) => {
                  Image.add("src");
                }
              );
            }
          );
        }
      );
    });
    if(linkto=='collection') {
      var active_item = $('<div></div>');
      active_item.addClass('col col25 col-maxwidth50 col-'+collection_handle);
      collection_container.append(active_item);
    };
    client.graphQLClient.send(collection_query).then(({ model }) => {
      const collection = model.collection;
      if(collection) {
        collection_id = collection.id,
        collection_title = collection.title.replace(brand+' / ','').replace('41-Thermal® ','');

        if ($.trim(collection_title_a.html()) === '') {
            collection_title_a.html(collection_title+' &raquo;');
        }

        for (c in collection.products) {
          const product = collection.products[c];
          if(product.title != null) {
            switch(linkto) {
              case 'collection':
                active_item.append(product_load_link('https://shop.'+brand_url+'.com/collections/'+collection_handle,collection_title,product.images));
                break;
              case 'product':
              default:
                var product_title = product.title;
                    product_title = product_title.split('(');
                    product_title = product_title[0];
                if(product_title.includes(' x ') || product_title.includes(' & ') || product_title.includes(' &amp; ')) {
                } else {
                  product_title = product_title.replace(brand+" ","");
                };
                container_counter++;
                //collection_container.append('<div id="'+collection_handle+'-'+container_counter.toString()+'" class="col '+col_size+' col-'+container_counter.toString()+'"><div class="padding"><a href="https://shop.'+brand_url+'.com/collections/'+brand_handle+'-'+handleize(product.productType)+'/products/'+product.handle+'"><span class="img"><img src="'+product.images[0].src.replace('.jpg','_large.jpg')+'" class="image" alt="" /></span><span class="title">'+product_title+'</span></a></div></div>');
                collection_container.append('<div id="'+collection_handle+'-'+container_counter.toString()+'" class="col '+col_size+' col-'+container_counter.toString()+'"><a href="https://shop.'+brand_url+'.com/collections/'+brand_handle+'-'+handleize(product.productType)+'/products/'+product.handle+'"><span class="img preserve-aspect ratio-3x2" style="background-image:url('+product.images[0].src.replace('.jpg','_large.jpg')+');">&nbsp;</span><span class="title">'+product_title+'</span></a></div>');
                if(container_counter == product_count) {
                  collection_container.append('<div class="col col100"><nav class="navigation spacer-top"><span class="bold"><a href="https://shop.'+brand_url+'.com/collections/'+brand_handle+'-new-arrivals">View '+collection_title+' &raquo;</a></span></nav></div>');
                };
                break;
            };
          };
        };
        
        var collection_total = $(collection_dom+' div.col').length,
            item_counter=1;

        if(linkto == 'product' && collection_total<30) {
          var show_mobile = collection_total-collection_total%3,
              show_tablet = collection_total-collection_total%5;
        }

        $(collection_dom+' div.col').each(function(){
          var col_class='col-'+item_counter;

          if(show_mobile && show_mobile<30 && item_counter>show_mobile) {
            col_class += col_class+' hide-mobile';
          };
          if(show_tablet && show_tablet<30 && item_counter>show_tablet) {
            col_class += col_class+' hide-tablet';
          }
          
          $(this).addClass(col_class);
          item_counter++;
        });
        
        if(linkto == 'collection') {
          collection_container.addClass('total-'+collection_total.toString());
        };
        $(collection_dom).show();
      } else if(linkto=='collection') {
        product_load(collection_handle,active_item);
        //active_item.remove();
      };
    });
  };
  
  // SHOP MENU
  $('.shop-menu').each(function(){
    if(shopmenu) {
      for (shopmenu_item of shopmenu) {
          collection_load(shopmenu_item,'#'+$(this).attr('id'),1,'collection');
      };
    };
  });

  // AUTO-LOAD COLLECTIONS
  $('.shopify-collection').each(function(){
    const container=$(this);
    collection_load(container.attr('data-collection'),'#'+container.attr('id'));
  });

  // AUTO-LOAD PRODUCTS
  $('.shopify-product').each(function(){
    const container=$(this);
    product_load(container.attr('data-product'),container);
  });

  // Cart Toggle
  /*
  fetch(`https://fullfactory-b2c.myshopify.com/api/2021-07/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': '19750c8b13b88c94b3a54674c5c17a4c',
  },
  body: JSON.stringify({
      query: `
        {
          cart {
            id
            lineItems(first: 1) {
              edges {
                node {
                  title
                }
              }
            }
          }
        }
      `,
    }),
  })
  .then(response => response.json())
  .then(data => {
    const cart = data.data.cart;
    if (cart && cart.lineItems.edges.length > 0) {
      console.log('There are items in the cart:');
      cart.lineItems.edges.forEach(item => {
        console.log(`- ${item.node.title}`);
      });
    } else {
      console.log('The cart is empty.');
    }
  })
  .catch(error => {
    console.error('Error:', error);
  });
  /*
  $.ajax({
      type: 'GET',
      url: 'https://fullfactory-b2c.myshopify.com/cart.json',
      dataType: 'json',
      success: function(data) { 
          var item_count = data['item_count'];
          if(item_count > 0) {
              $('#cart-link').addClass('hasitems');
          }
      }
  });
  */
});